import Page from 'components/layout/Page';
import { useI18n } from 'hooks/useI18n';
import { Element } from 'react-scroll';
import LaunchHero from './LaunchHero';
import LaunchNews from './LaunchNews';
import LaunchVideo from './LaunchVideo';

type LaunchSectionProps = {
  section: string;
  tooltip: string;
};

const LaunchComponent: React.FC = () => {
  const { t } = useI18n('launch-landing');

  const launchSections: LaunchSectionProps[] = [
    { section: 'hero', tooltip: t('nav.hero') },
    { section: 'manifest', tooltip: t('nav.manifest') },
    { section: 'news', tooltip: t('nav.news') }
  ];
  return (
    <Page hasScrollTop sections={launchSections}>
      <Element name="inicio" id="hero">
        <LaunchHero />
      </Element>
      <Element name="manifest" id="manifest">
        <LaunchVideo />
      </Element>
      <Element name="news" id="news">
        <LaunchNews />
      </Element>
    </Page>
  );
};

export default LaunchComponent;
